module.exports = __webpack_public_path__ + "static/media/enad.fafde02c.png";